import { render } from "./side-bar.vue?vue&type=template&id=ac62ead2&ts=true"
import script from "./side-bar.vue?vue&type=script&lang=ts"
export * from "./side-bar.vue?vue&type=script&lang=ts"

import "./side-bar.vue?vue&type=style&index=0&id=ac62ead2&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__